//
// Stylesheets
//
import './styles/style.scss';

//
// Control scripts
//
import './components/controls/background-controls/script';

//
// Block scripts
//
import './blocks/slideshow/script';
import './blocks/countup/script';
import './blocks/justified-gallery/script';
import './blocks/google-maps/script';
import './blocks/countdown/script';
import './blocks/image-comparison/script';
import './blocks/accordion/script';
import './blocks/tabs/script';
import './blocks/video-embed/script';
import './blocks/container/script';
import './blocks/banner/script';
import './blocks/post-types/script';
// import './blocks/tab-slider/script';
